module.exports = __webpack_public_path__ + "img/015-cross-platform.8bc955d3.svg";